import { DownloadIcon, LoadingSkeleton } from '@bloomfieldrobotics/canopy';
import { IconButton } from '@mui/material';
import { useDownloadSizeReport } from '../hooks/useDownloadSizeReport';

type Props = {
  customerId: string;
  varietyId: string | undefined;
  shouldUpdate: boolean;
  loading: boolean;
};

export const DownloadSizeReportButton = ({
  customerId,
  varietyId,
  shouldUpdate,
  loading,
}: Props) => {
  const { fileReady: sizeReportFileReady, downloadFile: downloadSizeReport } =
    useDownloadSizeReport(customerId, varietyId, shouldUpdate);

  return (
    <LoadingSkeleton
      variant='rounded'
      loading={!sizeReportFileReady || loading}
    >
      <IconButton
        size='small'
        sx={(theme) => ({
          color: theme.vars.palette.text.secondary,
          padding: 2,
          borderRadius: 1,
        })}
        onClick={downloadSizeReport}
        disabled={!sizeReportFileReady}
      >
        <DownloadIcon sx={{ width: '1rem', height: '1rem' }} />
      </IconButton>
    </LoadingSkeleton>
  );
};
